import React, { forwardRef, useEffect, useRef, useState } from 'react'
import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, IconButton, InputLabel, List, ListItem, MenuItem, Select, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material'
import '../../../assets/ExtraStyle.css'
import { CancelOutlined, Info } from '@mui/icons-material';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import QuestionList from '../QuestionLists/QuestionList.tsx';
import { ApiCopyClientEntityTemplate, ApiCopyTemplateQuestionCategory, ApiCopyVenueTemplate, ApiDeleteCatgory, ApiDowloadQuestions, ApiGetClientEntityByClientGroupId, ApiGetQuestionUsage, ApiGetVenueList, ApiUpdateTempQuestionData, GetCategories, GetTemplateQuestions, RemoveTemplateQuestions, UpdateVenueCategoryOrder, UpdateVenueQuestionOrder } from '../../../apiService/Core/Apicall.tsx';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RootState } from '../../../global/config/store.ts';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts';
import edit from '../../../assets/images/editIcon.png'
import useDebounce from '../CreateAllocations/UseDebounce.tsx';


interface DragItem {
    index: number;
}
const QuestionCard = forwardRef(({ question, index, moveQuestion, removequestion, updatequestion, setmaxScore, editId, maxScore, setEditId, setEditWeighted, editWeighted, colorHex, setcolorHex, setquestionGroup, setquestionLabel, questionGroup, questionLabel, entityTypeTemplateId }: { question: any; editId: string | null; colorHex: string | number | undefined; questionGroup: string | undefined, questionLabel: string | undefined; index: number; moveQuestion: (from: number, to: number) => void; removequestion: (id: number) => void; setEditId: (id: string | null) => void; setEditWeighted: (weight: number | string) => void; setmaxScore: (score: number | string) => void; setcolorHex: (colorHex: number | string) => void; setquestionGroup: (questionGroup: string) => void; setquestionLabel: (questionLabel: string) => void; editWeighted: any; maxScore: any; updatequestion: (id: number) => void; entityTypeTemplateId: any; }, ref) => {
    const dragRef = useRef<any>(null);
    const dropRef = useRef<any>(null);
    const DISABLE_DND = true;
    const [openQuestionUsage, setOpenQuestionUsage] = useState<boolean>(false)
    const [questionUsageList, setQuestionUsageList] = useState<any>([])
    const navigate = useNavigate()

    const [, drag] = useDrag({
        type: 'QUESTION',
        item: { index },
    });

    const [, drop] = useDrop({
        accept: 'QUESTION',
        hover: (draggedItem: DragItem) => {
            if (draggedItem.index !== index) {
                moveQuestion(draggedItem.index, index);
                draggedItem.index = index;
            }
        },
    });

    if (!DISABLE_DND) {
        drag(dragRef);
        drop(dropRef);
    }
    function decodeHtml(html) {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }


    const getQuestionUsage = async (questionId: number | string) => {
        try {
            const data = `?questionId=${questionId}`
            const res = await ApiGetQuestionUsage(data)
            if (res?.status) {
                setQuestionUsageList(res?.data)
                setOpenQuestionUsage(true)
            }
        } catch (error: any) {
            toast.error(error?.messsage)
        }
    }

    return (
        <Box ref={(node) => {
            dragRef.current = node;
            dropRef.current = node;
        }} key={index} className='my-2' border='1px solid #E0E0E0' borderRadius='5px' padding='10px'>
            <Box>

                <Box className='w-100 d-flex justify-content-end'>
                    <Typography variant='caption' className='text-end'>Index: {index}</Typography>
                </Box>
                <Box className='d-flex align-items-center justify-content-between my-3'>
                    <Box className='d-flex align-items-center' gap={1}>
                        <Typography className='text-main fw-bold'>Question ID: #{question.questionId.questionId}</Typography>
                        <Typography className='text-main fw-bold'>|</Typography>
                        <Typography className='fw-bold'>Category: {question?.questionId?.categoryId?.categoryName}</Typography>
                        <Typography className='fw-bold'>|</Typography>
                        <Typography className='fw-bold'>Type: {question?.questionId.qType?.length > 0 ? question.questionId.qType === "R" ? "Radio" : question.questionId.qType === "r" ? 'Radio Rating' : question.questionId.qType === "C" ? 'CheckBox' : "Text" : 'notFound'}</Typography>
                    </Box>
                    <Box className='d-flex align-items-center' gap={1}>
                        {/* <IconButton className='px-4 py-1 transform text-light' onClick={() => {
                        navigate(`/admin/create-new-question`, {
                            state: { questionData: question.questionId, entityTypeTemplateId: entityTypeTemplateId },
                        });
                    }}><img src={edit} height='25px'></img></IconButton> */}
                        <Link
                            to={`/admin/create-new-question/template/${entityTypeTemplateId}/${question.questionId.questionId}`}
                            className='px-4 py-1 transform text-light'

                        ><img src={edit} height='25px'></img></Link>
                        <Button onClick={() => { getQuestionUsage(question.questionId.questionId) }} className="link-btn whitespace text-white" sx={{ textTransform: 'none' }}>
                            Usage
                        </Button>
                        <Button className='px-4 py-1 bg-danger transform text-light' onClick={() => { removequestion(question.entityTypeTemplateQuestionId) }}>- Remove</Button>
                        {editId === question.questionId.questionId && <Button className='px-3 py-1 bg-grey transform text-light' onClick={() => { updatequestion(question.entityTypeTemplateQuestionId) }}>Save</Button>}
                    </Box>
                </Box>
                <Box>
                    <Typography className='fw-bold my-1 d-flex'>Q:&nbsp;<span dangerouslySetInnerHTML={{ __html: question.questionId.questions }} /></Typography>
                    <Box className='d-flex align-items-center' gap={3}>
                        <Box className='d-flex align-items-center'>
                            {/* <Box className='px-4 py-1 text-main' borderRight='1px solid #747247' bgcolor='#7472471A'>
                            <Typography>Ver {question.questionId.verNo}</Typography>
                        </Box> */}
                            <Typography className='px-4 my-2 py-1 text-main bg-light-primary'>{question.questionId.entityTypeId?.entityTypeName || 'undefined'}</Typography>
                        </Box>
                        {question.questionId.isPhotoRequire && (
                            <Box className=" bg-light-primary px-4 py-2" borderRadius='20px' width='fit-content'>
                                <Typography>Images - Min: {question.questionId.minPhoto}</Typography>
                            </Box>
                        )}
                    </Box>
                    {question.questionId.qOptionJson !== null && question.questionId.qOptionJson !== "" ? (
                        <List component='ol' className="question-options w-100 d-flex justify-content-between flex-wrap">
                            {(() => {
                                try {
                                    const parsedOptions = JSON.parse(question.questionId.qOptionJson);
                                    return parsedOptions.map((option, index) => (
                                        <ListItem key={index} className="col-6 option-text">
                                            <span>{index + 1}. &nbsp;</span>
                                            <span dangerouslySetInnerHTML={{ __html: option.value }} /> &nbsp;
                                            <span>(<span dangerouslySetInnerHTML={{ __html: option.optionScore }} />)</span>
                                            {option.radioRatingComment && (
                                                <span className="ml-1">({option.radioRatingComment})</span>
                                            )}
                                            <Tooltip
                                                title={
                                                    <Box>
                                                        <Typography variant='caption' display={'block'}><b>optionComment: </b> {option?.optionComment}</Typography>
                                                        <Typography variant='caption' display={'block'}><b>minChar: </b> {option?.minChar}</Typography>
                                                        <Typography variant='caption' display={'block'}><b>optionCommentType: </b> {option?.optionCommentType ?? "N/A"}</Typography>
                                                        {option?.optionImage && (<Typography variant='caption' display={'block'}><b>optionImage: </b> {option?.optionImage}</Typography>)}
                                                    </Box>
                                                }
                                            >
                                                <Info sx={{ fontSize: '16px', marginLeft: "8px" }} />
                                            </Tooltip>
                                        </ListItem>
                                    ));
                                } catch (error) {
                                    console.error("Invalid JSON in qOptionJson:", error);
                                    return (
                                        <Typography className="option-text text-danger">
                                            Error: Invalid JSON format
                                        </Typography>
                                    );
                                }
                            })()}
                        </List>
                    ) : (
                        <Typography className="option-text">
                            Answer will be a manual Text Entry
                        </Typography>
                    )}
                </Box>
                <Box className='d-flex mb-2 align-items-stretch flex-wrap'>
                    <Box className='px-4 py-1 text-main align-items-center d-flex' width='fit-content' borderRight='1px solid #747247' bgcolor='#7472471A'>
                        <Typography>Score : &nbsp;</Typography>
                        <FormControl>
                            <TextField
                                type='number'
                                onBlur={(e) => {
                                    const value = parseInt(e.target.value, 10);
                                    if (isNaN(value) || value < 0) {
                                        toast.error('Number Should be positive')
                                        setmaxScore(question.maxScore)
                                    }
                                }}
                                inputProps={{ min: 0 }}
                                disabled={editId !== question.questionId.questionId}
                                sx={{
                                    width: '50px',
                                    "& .MuiOutlinedInput-input": {
                                        color: "#747247",
                                        border: 'none !important',
                                        padding: '0px !important'
                                    },
                                    textAlign: 'center', border: 'none'
                                }}
                                onChange={(e) => { setmaxScore(e.target.value) }}
                                value={editId === question.questionId.questionId ? maxScore ? maxScore : question.maxScore ?? "" : question.maxScore ?? ""} />
                        </FormControl>
                        <Box component='img' onClick={() => setEditId(question.questionId.questionId)} src={edit} width='20px' height='20px'></Box>
                    </Box>
                    <Box className='px-4 d-flex align-items-center py-1 text-main' gap={2} width='fit-content' bgcolor='#7472471A' borderRight='1px solid #747247'>
                        <Typography width='fit-content' className='d-flex align-items-center'>Weightage : &nbsp;  </Typography>
                        <FormControl>
                            <TextField
                                type='number'
                                onBlur={(e) => {
                                    const value = parseInt(e.target.value, 10);
                                    if (isNaN(value) || value < 0) {
                                        toast.error('Number Should be positive')
                                        setEditWeighted(question.questionWeightage || Number(maxScore) === 0)
                                    }
                                }}
                                inputProps={{ min: 0 }}
                                disabled={editId !== question.questionId.questionId}
                                sx={{
                                    width: '50px',
                                    "& .MuiOutlinedInput-input": {
                                        color: "#747247",
                                        border: 'none !important',
                                        padding: '0px !important'
                                    },
                                    textAlign: 'center', border: 'none'
                                }}
                                onChange={(e) => { setEditWeighted(e.target.value) }}
                                // value={Number(maxScore) == 0 ? 0 : editId === question.questionId.questionId ? editWeighted ? editWeighted : question.questionWeightage : question.questionWeightage} />
                                value={editId === question.questionId.questionId ? editWeighted ? editWeighted : question.questionWeightage ?? "" : question.questionWeightage ?? ""} />
                        </FormControl>
                        <Box component='img' onClick={() => setEditId(question.questionId.questionId)} src={edit} width='20px' height='20px'></Box>
                    </Box>
                    <Box className='px-4 d-flex align-items-center py-1 text-main' gap={1} width='fit-content' bgcolor='#7472471A'>
                        <Typography width='fit-content' className='d-flex align-items-center'>colour : &nbsp;</Typography>
                        <FormControl>
                            <TextField
                                type='color'
                                inputProps={{ min: 0 }}
                                disabled={editId !== question.questionId.questionId}
                                sx={{
                                    width: '50px',
                                    "& .MuiOutlinedInput-input": {
                                        color: "#747247",
                                        border: 'none !important',
                                        padding: '0px !important'
                                    },
                                    textAlign: 'center', border: 'none'
                                }}
                                onChange={(e) => { setcolorHex(e.target.value) }}
                                value={editId === question.questionId.questionId ? colorHex ? colorHex : question.colorHex : question.colorHex} />
                        </FormControl>

                        <Box component='img' onClick={() => setEditId(question.questionId.questionId)} src={edit} width='20px' height='20px'></Box>
                    </Box>
                    <Box className='px-4 py-1 text-main align-items-center d-flex' width='fit-content' bgcolor='#7472471A'>
                        <Typography>Question Order : {question?.displayOrder ?? 'N/A'}</Typography>
                    </Box>
                </Box>
                <Typography className="d-flex">
                    Description: &nbsp;<span dangerouslySetInnerHTML={{ __html: decodeHtml(question.questionId.questionDescription) }} />
                </Typography>
                <Typography className="d-flex">
                    Hint: &nbsp;<span dangerouslySetInnerHTML={{ __html: decodeHtml(question.questionId.questionHint) }} />
                </Typography>
            </Box>
            <Dialog fullWidth open={openQuestionUsage}>
                <Box className='d-flex align-items-center justify-content-between p-3'>
                    <Typography className="fw-bold" variant="h5">Question Usage</Typography>
                    <IconButton onClick={() => { setOpenQuestionUsage(false); setQuestionUsageList([]); }}>
                        <CancelOutlined />
                    </IconButton>
                </Box>
                <Box className='p-3'>
                    {questionUsageList?.businessUsage?.length > 0 && (
                        <Box className='mb-3'>
                            <Typography variant="h6">Businesses</Typography>
                            <List sx={{ listStyleType: "disc", pl: 4 }}>
                                {
                                    questionUsageList?.businessUsage?.map((item: any, index: number) => (
                                        <ListItem key={index}
                                            className="px-0"
                                            sx={{ display: "list-item !important", listStyle: 'outside', py: 0 }}>
                                            <Link
                                                to={`/admin/create-client-template/${item?.clientEntityId}`}
                                                // className="table-row-background fs-14 link-btn"
                                                style={{ textDecoration: "underline !important", color: "#75724C" }}
                                                target="__blank"
                                            > {item?.entityName}
                                            </Link>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Box>
                    )}

                    {questionUsageList?.venueUsage?.length > 0 && (
                        <Box className='mb-3'>
                            <Typography variant="h6">Sites</Typography>
                            <List component="ul" sx={{ listStyleType: "disc", pl: 4 }}>
                                {
                                    questionUsageList?.venueUsage?.map((item: any, index: number) => (
                                        <ListItem key={index}
                                            className="px-0"
                                            sx={{ display: "list-item", listStyle: 'outside', py: 0 }}>
                                            <Link
                                                to={`/admin/create-venue-site-template/${item?.venueId}`}
                                                // onClick={() => navigateToVenueSiteQuestion(venue)}
                                                style={{ textDecoration: "underline !important", color: "#75724C" }}
                                                target="__blank"
                                            >
                                                {item?.venueName}
                                            </Link>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Box>
                    )}
                    {questionUsageList?.templateUsage?.length > 0 && (
                        <Box className='mb-3'>
                            <Typography variant="h6">Question Template</Typography>
                            <List component="ul" sx={{ listStyleType: "disc", pl: 4 }}>
                                {
                                    questionUsageList?.templateUsage?.map((item: any, index: number) => (
                                        <ListItem key={index}
                                            className="px-0"
                                            sx={{ display: "list-item", listStyle: 'outside', py: 0 }}>
                                            <Link to={`/admin/create-new-template/${item?.templateName}/${item?.entityTypeTemplateId}`}
                                                style={{ textDecoration: "underline !important", color: "#75724C" }}
                                                target="__blank"

                                            >
                                                {item?.templateName}</Link>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Box>
                    )}
                </Box>
            </Dialog>
        </Box>


    );
});

function CreateNewTemplate() {

    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const Clientlist = useSelector((state: RootState) => state.client.clientList)
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
    const [clientEntityList, setClientEntityList] = useState<any>([])
    const [clientEntityId, setClientEntityId] = useState<string | null>(null)
    const dispatch = useDispatch()
    const [ClientId, setClientId] = useState(null)
    const [category, setcategorey] = useState<any>([])
    const [activequestions, setactivequestions] = useState<any>([])
    const [selectedCategory, setselectedCategory] = useState<number | string>('')
    const [TemplateQuestions, setTemplateQuestions] = useState<any>('')
    const [addedData, setAddedData] = useState<number[]>([]);
    const [addedFilters, setAddedFilters] = useState<number[]>([]);
    const [alignment, setAlignment] = useState<number>(addedFilters && addedFilters[1]);
    const [reload, setreload] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<number>(0);
    const [ischange, setischange] = useState<boolean>(false);
    const [editId, setEditId] = useState<string | null>(null);
    const [editWeighted, setEditWeighted] = useState<string | number>();
    const [editColorHex, setEditcolorHex] = useState<string | number>();
    const [questionGroup, setquestionGroup] = useState<string>('');
    const [questionLabel, setquestionLabel] = useState<string>('');
    const [maxScore, setmaxScore] = useState<string | number>();
    const [categoryName, setCategoryName] = useState<any>(null)
    const [open, setOpen] = useState(false);
    const [newCategoryId, setNewCategoryId] = useState<any>(null);
    const [iscategorychange, setiscategorychange] = useState<boolean>(false);
    const navigate = useNavigate()
    const [venueName, setVenueName] = useState([])
    const [venueNameValue, setVenueNameValue] = useState<any>("")
    const debouncedClientEntityId = useDebounce(clientEntityId, 500)
    const { templateName, entityTypeTemplateId }: any = useParams()






    const ApiCallGetVenueList = async (debouncedClientEntityId?: any) => {
        let data = `?offset=0&limit=500`
        if (clientEntityId) {
            data += `&clientEntityId=${clientEntityId}&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        } else if (selectedClient?.clientGroupName) {
            data += `&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        }
        const res = await ApiGetVenueList(data)
        const response = res?.data.map((item: any) => ({
            label: item.venueName,
            value: item.venueId,
            state: item.state,
            entityTypeName: item.entityTypeName
        }))
        setVenueName(response)
    }

    useEffect(() => {
        if (debouncedClientEntityId || selectedClient?.clientGroupName) {
            ApiCallGetVenueList(debouncedClientEntityId)
        } else {
            setVenueName([]) // Clear venue list when business is cleared
            setVenueNameValue(null) // Also clear selected venue
        }
    }, [debouncedClientEntityId, selectedClient?.clientGroupName])



    const handleQuestionListUpdate = () => {
        setRefresh((prev) => prev + 1);
    };
    const moveQuestion = (fromIndex, toIndex) => {
        const updatedQuestions = [...activequestions];
        const [movedQuestion] = updatedQuestions.splice(fromIndex, 1);
        updatedQuestions.splice(toIndex, 0, movedQuestion);
        setactivequestions(updatedQuestions);
        setischange(!ischange)
    };
    // const location = useLocation();
    // const templateData = location.state?.templateData;
    useEffect(() => {
        if (category.length > 0) {
            setselectedCategory(category[category.length - 1]?.categoryId);
        }
    }, [selectedCategory, category]);
    useEffect(() => {
        const fetchcategory = async () => {
            try {
                const categories = await GetCategories()
                setcategorey(categories.data)
            }
            catch (error) {
                toast.error(error)
            }

        }

        fetchcategory()
    }, [])

    const fetchtselectedquestions = async () => {
        try {
            const response = await GetTemplateQuestions(parseInt(entityTypeTemplateId))
            if (!response?.data) {
                setAddedFilters([])
            }
            setreload(false)
            setTemplateQuestions(response.data)

            // setreload(false)
            // response.data.map((item:any) => {
            //     setAddedFilters(prevFilters =>
            //         prevFilters.includes(item.questionId.categoryId.categoryId)
            //             ? prevFilters
            //             : [...prevFilters, item.questionId.categoryId.categoryId]
            //     );
            //     setAlignment(response.data[0].questionId.categoryId.categoryId)

            // })
            let filteredquestions: any[] = [];
            let filteredcategories: any[] = [];
            const categoryIds = response.categoryDisplayOrderIds
                ? response.categoryDisplayOrderIds.split(',').filter((id) => id.trim() !== '').map((id) => parseInt(id.trim(), 10))
                : [];

            categoryIds.map((orderId: number) => {
                response.data.map((question: any) => {

                    if (question?.questionId?.categoryId?.categoryId === orderId) {
                        filteredquestions = [...filteredquestions, question];
                    }
                })
            })
            filteredquestions.map(item => {
                filteredcategories = [...new Set([...filteredcategories, item?.questionId?.categoryId?.categoryId])];
            })

            if (filteredcategories.length > 0 && JSON.stringify(filteredcategories) !== JSON.stringify(addedFilters)) {
                setAddedFilters(filteredcategories);
                setAlignment(filteredcategories[0])
            }
            else if (filteredcategories.length < 1) {
                // response.data.map((item: any) => {
                //     setAddedFilters(prevFilters =>
                //         prevFilters.includes(item?.questionId?.categoryId?.categoryId)
                //             ? prevFilters
                //             : [...prevFilters, item?.questionId?.categoryId?.categoryId]
                //     );
                //     setAlignment(response?.data[0]?.questionId.categoryId.categoryId)


                // })
                if (response.data.length > 0) {
                    const newCategoryIds = response.data.map(
                        item => item.questionId.categoryId.categoryId
                    );

                    setAddedFilters(prevFilters => {
                        const updatedFilters = [
                            ...new Set([...prevFilters, ...newCategoryIds])
                        ];
                        return updatedFilters;
                    });
                }
                setAlignment(response.data[0].questionId.categoryId.categoryId)
            }
        }
        catch (error: any) {
            toast.error(error.message)
        }

    }

    useEffect(() => {
        fetchtselectedquestions()
    }, [reload, refresh])

    const handleChange2 = (event) => {
        setAddedFilters(prevFilters =>
            prevFilters.includes(event)
                ? prevFilters
                : [...prevFilters, event]
        );
    };

    const handleAlignment = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: number,
    ) => {
        setAlignment(newAlignment);
    };

    const removequestion = async (entityTypeTemplateQuestionId) => {
        try {
            const response = await RemoveTemplateQuestions(entityTypeTemplateQuestionId)
            toast.success(response.message)
            setreload(true)
        }
        catch (error) {
            toast.error(error)
        }

    }
    useEffect(() => {
        if (TemplateQuestions) {
            const activeCategory = TemplateQuestions.filter(q => q?.questionId?.categoryId?.categoryId === alignment)
                .sort((a, b) => a.displayOrder - b.displayOrder);
            setactivequestions(activeCategory);
        }
    }, [alignment, TemplateQuestions]);

    useEffect(() => {
        if (TemplateQuestions) {
            if (activequestions) {
                const updatequestionOrder = async () => {
                    const updatedMap = {
                        type: "template_questions",
                        questionOrders: activequestions?.map((question, index) => ({
                            entityTypeTemplateQuestionId: question.entityTypeTemplateQuestionId,
                            displayOrder: index
                        })) || []
                    };
                    try {
                        const response = await UpdateVenueQuestionOrder(updatedMap)
                        // alert(response.message)
                    }
                    catch (error) {
                        toast.error(error)
                    }
                }
                updatequestionOrder()
            }
        }
    }, [ischange]);

    useEffect(() => {
        if (Clientlist.length > 2) {
            // setSelectedClient(Clientlist[2])
            setClientId(Clientlist[2].clientGroupName)
        }
    }, [Clientlist])

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
        if (!ClientId) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            // console.log(res.data)
            setClientEntityList(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }
    useEffect(() => {
        handleGetClientList()
    }, [ClientId])



    const handleCopyTemplate = async () => {
        try {
            if (!clientEntityId && !venueNameValue) {
                toast.error("Please Select Business or site To Copy Template");
                return;
            }

            const data = `?clientEntityId=${clientEntityId}&clientEntityTemplateId=${entityTypeTemplateId}`;
            const data2 = `?venueId=${venueNameValue}&entityTypeTemplateId=${entityTypeTemplateId}`

            const res = venueNameValue ? await ApiCopyVenueTemplate(data2) : await ApiCopyClientEntityTemplate(data);
            if (res?.categoryOrder) {
                const updateOrderData = {
                    type: "template_questions",
                    entityTypeTemplateId: entityTypeTemplateId,
                    categoryDisplayOrderIds: res?.categoryOrder
                };

                try {
                    await UpdateVenueCategoryOrder(updateOrderData);
                } catch (orderError: any) {
                    console.error("Error updating display order:", orderError);
                    toast.error(`Template copied but failed to update display order: ${orderError.message}`);
                }
            }
            else {
                toast.success(res?.message);
            }
            fetchtselectedquestions();

        } catch (error: any) {
            console.error("Error Copying Template.", error);
            toast.error(error?.message);
        }
    }

    const updatequestion = async (entityTypeTemplateQuestionId: any) => {
        const data = `?entityTypeTemplateQuestionId=${entityTypeTemplateQuestionId}`
        const data1 = {
            ...(editWeighted && { questionWeightage: Number(editWeighted) }),
            ...(maxScore && { maxScore: Number(maxScore) }),
            ...(editColorHex && { colorHex: editColorHex }),
        }
        try {
            const response = await ApiUpdateTempQuestionData(data, data1)
            localStorage.setItem('alignment', alignment.toString())
            toast.success(response.message)
            setreload(true)
            setEditId(null)
        }
        catch (error: any) {
            toast.error(error)
        }

    }

    const handleCloseDialog = () => {
        setOpen(false);
        setNewCategoryId(null)
    };

    const handleCopyQuestion = async () => {
        const questionIds = activequestions.map((q: any) => q.questionId.questionId) || [];
        if (!newCategoryId) {
            toast.error("Please Select Category To Replace.");
            return
        }
        if (!alignment) {
            toast.error("Please Select Category");
            return;
        }
        try {
            const data = {
                newCategoryId: newCategoryId,
                entityTypeTemplateId: entityTypeTemplateId,
                oldCategoryId: alignment,
                questions: questionIds
            }
            const res = await ApiCopyTemplateQuestionCategory(data);
            toast.success(res.message);
            setOpen(false);
            fetchtselectedquestions();
        } catch (error: any) {
            console.error("Error Copying Question", error);
            toast.error(error)
        }
    }


    // useEffect(() => {
    //     if (TemplateQuestions && addedFilters && category) {
    //         const updatequestionOrder = async () => {
    //             // const updatedCategory = {
    //             //     type: "client_entity_questions",
    //             //     clientEntityId: clientData.clientEntityId,
    //             //     categoryDisplayOrderIds: addedFilters?.length > 0 && addedFilters.map((filter, index) => {
    //             //         const matchedCategory = category.find((cat) => cat.categoryId === filter);
    //             //         const categoryId = matchedCategory && matchedCategory.categoryId;
    //             //         return categoryId
    //             //     })
    //             //         .join(",")
    //             // };
    //             const validCategoryIds = addedFilters
    //                 .map((filter) =>
    //                     category?.find((cat: any) => cat?.categoryId === filter)?.categoryId
    //                 )
    //                 .filter(Boolean);
    //             if (validCategoryIds.length === 0) return;

    //             const updatedCategory = {
    //                 type: "template_questions",
    //                 entityTypeTemplateId: templateData?.entityTypeTemplateId,
    //                 categoryDisplayOrderIds: validCategoryIds.join(","),
    //             };
    //             try {
    //                 const response = await UpdateVenueCategoryOrder(updatedCategory)
    //                 fetchtselectedquestions();
    //                 // alert(response.message)
    //             }
    //             catch (error: any) {
    //                 toast.error(error.message)
    //             }
    //         }
    //         updatequestionOrder()

    //     }
    // }, [addedFilters, category]);

    const handleDeleteCategory = async (id: any) => {
        try {
            const data = {
                type: "template_questions",
                entityTypeTemplateId: entityTypeTemplateId,
                categoryDisplayOrderId: id
            }
            const res = await ApiDeleteCatgory(data);
            if (res.status) {
                fetchtselectedquestions();
                toast.success(res.message)
            }
        } catch (error: any) {
            console.error("Error Deleting Category:", error)
            toast.error(error);
        }
    }

    useEffect(() => {
        setSelectedClient(selectedClientName)
    }, [selectedClientName])

    const downaloadQuestions = async (clientEntityId: number, entityName: string) => {
        try {
            const data = `?entityTypeTemplateId=${clientEntityId}&templateName=${entityName}`
            const res = await ApiDowloadQuestions(data);
            const blob = new Blob([res], {
                type: 'application/pdf',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${entityName}-Questions.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            // alert(error)
            toast.error("Please set the question and category order, then try again.");
        }
    }

    return (
        <Box className='container-fluid bg-light create-new-template extra' boxShadow='0px 0px 3px #000000' minHeight='calc(100vh - 165px)' padding='30px 20px 20px 20px '>
            {/* <Box className='d-flex align-items-center justify-content-between'>
                <Typography className='fs-18'>Manage Questions</Typography>
            </Box> */}
            {/* <Divider className='my-4 mb-0' /> */}
            <Box className="d-flex my-2 justify-content-between align-items-center">
                <Typography className='m-0 p-0' variant='subtitle1'>{/*{templateData?.entityTypeTemplateId || 0} &nbsp;*/}{templateName || "Undefine"}</Typography>

                <Box className="p-2 d-flex" paddingTop={'0px !important'} gap={1}>
                    <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                        <Autocomplete
                            disablePortal
                            autoComplete={false}
                            id="mm-autocomplete"
                            options={Clientlist}
                            value={selectedClient}
                            getOptionLabel={(option) => option?.clientGroupName}
                            isOptionEqualToValue={(option, value) => option.clientGroupDBName === value.clientGroupDBName}
                            onChange={(event, newValue: any) => {
                                // setSelectedClient(newValue)
                                dispatch(setSelectedClientGroup(newValue))
                                setClientId(newValue?.clientGroupName || null)
                                if (
                                    !newValue ||
                                    (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)
                                ) {
                                    setClientEntityId(null)
                                    setClientEntityList([])
                                }
                            }}
                            renderInput={(params) => <TextField {...params}
                                InputLabelProps={{
                                    shrink: false,
                                }}
                                sx={{
                                    "& .MuiInputLabel-root": {
                                        top: '-30px !important'
                                    }
                                }}
                                label="Select Client" />}
                            size="small"
                        />
                    </FormControl>
                    <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                        <Autocomplete
                            disablePortal

                            id="beacon-autocomplete"
                            options={clientEntityList.filter((item: any) => item.clientEntityId !== null)}
                            getOptionLabel={(option) => option?.entityName || ""}
                            onChange={(event, newValue: any) => {
                                setClientEntityId(newValue?.clientEntityId || null)
                            }}
                            value={clientEntityList.find((option: any) => option?.clientEntityId === clientEntityId) || null}
                            renderInput={(params) => <TextField {...params}
                                InputLabelProps={{
                                    shrink: false,
                                }}
                                sx={{
                                    "& .MuiInputLabel-root": {
                                        top: '-30px !important'
                                    }
                                }}
                                label="Select Business" />}
                            size="small"
                        />
                    </FormControl>

                    <FormControl size="small" sx={{ width: { xs: "100%", md: 200 } }}>
                        <Autocomplete
                            disablePortal
                            id="mm-autocomplete"
                            options={venueName}
                            getOptionLabel={(option: any) => `${option?.label} (${option?.state}) (${option?.entityTypeName})`}
                            value={venueName.find((option: any) => option.value === venueNameValue) || null}
                            onChange={(event, newValue: any) => {
                                setVenueNameValue(newValue?.value || null)
                                // setSearchText("")
                            }}
                            defaultValue=""
                            renderInput={(params) => <TextField {...params}
                                InputLabelProps={{
                                    shrink: false,
                                }}

                                sx={{
                                    "& .MuiInputLabel-root": {
                                        top: '-30px !important'
                                    }
                                }}
                                label="Search Site" />}
                            size="small"
                        />
                    </FormControl>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="table-row-background"
                        onClick={handleCopyTemplate}
                    >
                        Copy Template
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="table-row-background"
                        onClick={() => setOpen(true)}
                    >
                        Update Category
                    </Button>
                </Box>
            </Box>
            <Divider className='my-3' />
            <Box className='d-flex align-items-center  justify-content-end my-1 mb-3'>
                <Button
                    variant="contained"
                    onClick={() => downaloadQuestions(entityTypeTemplateId,templateName)}
                    className="table-row-background fs-14 mr-2"
                >
                    Download Questions
                </Button>
                <Link
                    to={`/admin/change-template-question-order/${templateName}/${entityTypeTemplateId}`}
                    className='bg-grey text-light link-btn whitespace px-3 py-2'
                >
                    Change Order
                </Link>
                {/* <Button onClick={() => { navigate('/admin/change-template-question-order', { state: { entityTypeTemplateId: templateData?.entityTypeTemplateId, entityTemplateName:templateData?.templateName } }) }} className='bg-grey col-1 text-light whitespace px-3 py-1'>Change Order</Button> */}
            </Box>
            <Box className='d-flex' gap={2}>
                <Box className='w-50 p-2' border='1px solid #E0E0E0'>
                    <QuestionList venueId={null} onUpdate={handleQuestionListUpdate}
                        entityTypeTemplateId={entityTypeTemplateId} clientEntityId={null} />
                </Box>
                <Box className='w-50 p-2' border='1px solid #E0E0E0'>
                    <Typography className='fs-18 fw-bold mb-2 mt-1'>{templateName} Finalised Questions</Typography>
                    <Box className='d-flex align-items-stretch'>
                        <FormControl className='col-2'>
                            <Select value={selectedCategory ?? ''} renderValue={() => "Select Category"} onChange={(e) => { setselectedCategory(Number(e.target.value)); handleChange2(e.target.value) }}>

                                {category.length > 0 &&
                                    category.map((cat, index) => (
                                        <MenuItem value={cat?.categoryId} key={index}>
                                            {cat.categoryName}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        <ToggleButtonGroup
                            sx={{ overflow: 'auto' }}
                            color="primary"
                            value={alignment}
                            exclusive
                            onChange={handleAlignment}
                            aria-label="Platform"
                        >
                            {addedFilters.map((filter, index) => {
                                const matchedCategory = category.find((cat) => cat?.categoryId === filter);
                                const categoryName = matchedCategory ? matchedCategory.categoryName : "Unknown";
                                return (
                                    <ToggleButton
                                        className="transform d-flex align-items-center"
                                        sx={{ gap: 2, fontSize: '16px', whiteSpace: 'nowrap' }}
                                        key={index}
                                        value={filter}
                                    >
                                        {categoryName}
                                        <span
                                            className='d-flex align-items-center'
                                            onClick={() => {
                                                const isConfirm = window.confirm("Are you sure you want to delete this category with question ?")
                                                if (isConfirm) {
                                                    handleDeleteCategory(matchedCategory?.categoryId)
                                                }
                                            }
                                            }
                                        >
                                            <CancelOutlined sx={{ fontSize: '18px' }} />
                                        </span>
                                    </ToggleButton>
                                )
                            })}
                        </ToggleButtonGroup>

                    </Box>
                    {/* {TemplateQuestions?.length > 0 && TemplateQuestions.map((question, index) => (
                         alignment === question.questionId.categoryId?.categoryId && (
                        
                    )))} */}
                    <DndProvider backend={HTML5Backend}>
                        {/* {TemplateQuestions?.length > 0 && TemplateQuestions.map((question, index) => (
                            alignment === question.questionId.categoryId?.categoryId && (

                                <QuestionCard key={index} removequestion={removequestion} question={question} index={index} moveQuestion={moveQuestion} />
                            )))} */}
                        {
                            activequestions?.length > 0 && activequestions.map((question, index) => (
                                <QuestionCard key={index} removequestion={removequestion} question={question} index={index} moveQuestion={moveQuestion} colorHex={editColorHex} questionGroup={questionGroup} questionLabel={questionLabel} setquestionLabel={setquestionLabel} setquestionGroup={setquestionGroup} setcolorHex={setEditcolorHex} setEditId={setEditId} editWeighted={editWeighted} setEditWeighted={setEditWeighted} maxScore={maxScore} setmaxScore={setmaxScore} editId={editId} updatequestion={updatequestion} entityTypeTemplateId={entityTypeTemplateId} />
                            ))
                        }
                    </DndProvider>


                </Box>
            </Box>

            <Dialog
                open={open}
                onClose={handleCloseDialog}
                maxWidth={false}
                PaperProps={{
                    sx: {
                        width: "400px",
                        height: "400px",
                        maxWidth: "none",
                    },
                }}
            >
                <DialogTitle>
                    Select New Category
                </DialogTitle>

                <DialogContent>
                    <Box sx={{ mt: 2 }}>
                        <Autocomplete
                            disablePortal
                            id="mm-autocomplete"
                            options={category}
                            getOptionLabel={(option: any) => `${option?.categoryName}`}
                            value={category.find((option: any) => option?.categoryId === newCategoryId) || null}
                            onChange={(event, newValue) => {
                                setNewCategoryId(newValue?.categoryId)
                                setCategoryName(newValue?.categoryName)
                            }}
                            defaultValue=""
                            renderInput={(params) => <TextField {...params} label="Select Category" />}
                            size="small"
                        />
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseDialog} sx={{ color: "#ADB792", borderColor: "#ADB792", }} variant='outlined'>
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            const alignedCategory = category.find(
                                (cat: any) => cat?.categoryId === alignment
                            );

                            const alignedCategoryName = alignedCategory?.categoryName || "";
                            const isConfirm = window.confirm(`Are you sure you want to update ${alignedCategoryName} category to ${categoryName} category?`)
                            if (isConfirm) {
                                handleCopyQuestion()
                            }
                        }}
                        variant="contained"
                        className='table-row-background'
                    >
                        Update
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>
    )
}

export default CreateNewTemplate
